'use client';

import React from 'react';
import { EntitySelectorCombobox } from '@/_components';
import styles from './EntityParamSelector.module.css';
import { usePathname, useRouter } from 'next/navigation';
import type { EntityParamSelectorProps } from './EntityParamSelector.types';

export const EntityParamSelector: React.FC<EntityParamSelectorProps> = ({
  companyId,
}) => {
  const pathName = usePathname();
  const { replace } = useRouter();

  const onChange = (newCompanyId: number | undefined): void => {
    const newUrl: string =
      typeof newCompanyId === 'number'
        ? `${pathName}?entityId=${newCompanyId}`
        : pathName;

    return replace(newUrl);
  };

  return (
    <div className={styles.entityParamSelector}>
      <EntitySelectorCombobox
        preselectedEntityId={!!companyId ? parseInt(companyId) : undefined}
        isLabelHidden={true}
        onChange={onChange}
        label="Select Entity"
      />
    </div>
  );
};
